document.addEventListener('DOMContentLoaded', function () {
  console.log('Script loaded for variant control');

  // Target the main product form dynamically
  const productForm = document.querySelector('form[id^="product-form-template--"][action="/cart/add"]');
  const sectionId = productForm ? productForm.querySelector('input[name="section-id"]').value : null;
  if (!productForm || !sectionId) {
    console.warn('Main product form or section-id not found. Ensure this is a product page with a form[action="/cart/add"].');
    return;
  }
  console.log('Main product form found:', productForm);
  console.log('Section ID:', sectionId);

  // Get all variant radio inputs within the variant-radios section
  const variantRadios = document.querySelector(`variant-radios[data-section="${sectionId}"]`);
  const variantInputs = variantRadios ? variantRadios.querySelectorAll('input[type="radio"]') : [];
  if (variantInputs.length === 0) {
    console.log('No variant radio inputs found. Skipping variant-related functionality.');
    return;
  }
  console.log('Variant inputs found:', variantInputs.length);

  // Get the hidden variant ID input
  const variantInput = productForm.querySelector('input[name="id"]');
  if (!variantInput) {
    console.warn('Hidden variant ID input not found.');
  } else {
    console.log('Variant ID input found:', variantInput);
  }

  // Get the Add to Cart button
  const addToCartButton = productForm.querySelector('button[name="add"]');
  if (!addToCartButton) {
    console.warn('Add to Cart button not found.');
  } else {
    console.log('Add to Cart button found:', addToCartButton);
  }

  // Get the span that displays the selected variant value
  const variantDisplaySpan = document.querySelector('.append-options-values');
  if (!variantDisplaySpan) {
    console.warn('Variant display span (.append-options-values) not found.');
  } else {
    console.log('Variant display span found:', variantDisplaySpan);
  }

  // Uncheck all variant inputs on page load
  variantInputs.forEach(input => {
    input.checked = false;
    console.log(`Unchecked input: ${input.name} - ${input.value}`);
  });

  // Clear the hidden variant ID input
  if (variantInput) {
    variantInput.value = '';
    console.log('Cleared variant ID input');
  }

  // Clear the displayed variant value
  if (variantDisplaySpan) {
    variantDisplaySpan.textContent = '';
    console.log('Cleared variant display span');
  }

  // Function to update Add to Cart button state
  function updateAddToCartButton() {
    const isVariantSelected = Array.from(variantInputs).some(radio => radio.checked);
    if (addToCartButton) {
      addToCartButton.classList.toggle('disabled', !isVariantSelected);
      console.log('Add to Cart button state:', isVariantSelected ? 'enabled' : 'disabled');
    }
  }

  // Function to show error message using alert
  function showErrorMessage(message) {
    alert(message);
    console.log('Showing error message:', message);
  }

  // Disable Add to Cart button styling initially
  updateAddToCartButton();

  // Get variant data from script tag
  let variantData = [];
  const variantScript = variantRadios ? variantRadios.querySelector('script') : null;
  if (variantScript) {
    try {
      variantData = JSON.parse(variantScript.textContent);
      console.log('Variant data parsed:', variantData);
    } catch (e) {
      console.error('Error parsing variant data:', e);
    }
  } else {
    console.warn('Variant data script not found.');
  }

  // Add event listeners to variant radio buttons
  variantInputs.forEach(radio => {
    radio.addEventListener('change', function () {
      if (this.checked) {
        // Update the hidden input with the selected variant ID
        const selectedOption = this.value;
        const selectedVariant = variantData.find(variant => {
          return variant.options.includes(selectedOption);
        });
        if (selectedVariant && variantInput) {
          if (!selectedVariant.available) {
            // Show error if variant is unavailable
            showErrorMessage('This variant is unavailable.');
            variantInput.value = '';
            if (variantDisplaySpan) variantDisplaySpan.textContent = this.value;
            updateAddToCartButton();
          } else {
            // Proceed with selection
            variantInput.value = selectedVariant.id;
            console.log(`Selected variant: ${selectedOption}, ID: ${selectedVariant.id}`);
            // Update the displayed variant value
            if (variantDisplaySpan) {
              variantDisplaySpan.textContent = selectedOption;
              console.log(`Updated display span to: ${selectedOption}`);
            }
            updateAddToCartButton();
          }
        } else {
          console.warn('No matching variant found or variantInput missing for:', selectedOption);
          showErrorMessage('Error selecting variant. Please try again.');
          updateAddToCartButton();
        }
      } else {
        console.log('Unchecked variant:', this.value);
      }
    });
  });

  // Add event listener to Add to Cart button
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function (event) {
      const isVariantSelected = Array.from(variantInputs).some(radio => radio.checked);
      if (!isVariantSelected || !variantInput || !variantInput.value) {
        event.preventDefault();
        showErrorMessage('Please select an available variant before adding to cart.');
        console.log('Add to Cart blocked: No valid variant selected');
      } else {
        // Verify variant availability before allowing add to cart
        const selectedVariantId = variantInput.value;
        const selectedVariant = variantData.find(variant => variant.id.toString() === selectedVariantId);
        if (selectedVariant && !selectedVariant.available) {
          event.preventDefault();
          showErrorMessage('This variant is unavailable.');
          console.log('Add to Cart blocked: Selected variant is unavailable');
        } else {
          console.log('Add to Cart allowed: Variant ID:', variantInput.value);
        }
      }
    });
  }

  // Add CSS for disabled button
  const style = document.createElement('style');
  style.textContent = `
    .product-form__submit.disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  `;
  document.head.appendChild(style);
  console.log('CSS styles applied');
});


document.addEventListener('DOMContentLoaded', function () {
  const variantElements = document.querySelectorAll('.cstm_variant_prod');

  if (variantElements.length > 0) {
    variantElements.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const url = el.getAttribute('data-product-url');
        if (url) {
          window.location.href = url;
        }
      });
    });
  }
});

